/**
 * Atlas & Grey ‚Äì Warenkorb & Kaufbereich (Horizon)
 * - <atlasgrey-cart-timer>: Countdown im Reservierungs-Balken (Session-weit gemerkt)
 * - <atlasgrey-cart-upsell>: ‚ÄûKunden kaufen oft zusammen‚Äú ‚Äì Produkt per /cart/add.js in den Warenkorb,
 *   Drawer/Seite werden wie bei der Buybox √ºber CartAddEvent aktualisiert.
 */
import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

const STORAGE_KEY = 'atlasgrey_cart_reserved_until';

if (!customElements.get('atlasgrey-cart-timer')) {
  class AtlasgreyCartTimer extends HTMLElement {
    connectedCallback() {
      this.timeEl = this.querySelector('[data-time]');
      this.minutes = Math.max(1, Number(this.dataset.minutes) || 10);
      this.expiredMode = this.dataset.expired || 'hide';
      this.deadline = this.readDeadline();
      this.tick();
      this.interval = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    readDeadline() {
      let stored = null;
      try {
        stored = Number(window.sessionStorage.getItem(STORAGE_KEY));
      } catch (e) {
        stored = null;
      }
      const now = Date.now();
      if (stored && stored > now) return stored;
      if (stored && stored <= now && this.expiredMode === 'hide') return stored;
      const fresh = now + this.minutes * 60 * 1000;
      try {
        window.sessionStorage.setItem(STORAGE_KEY, String(fresh));
      } catch (e) {
        /* Storage nicht verf√ºgbar ‚Äì Timer l√§uft nur f√ºr diese Ansicht */
      }
      return fresh;
    }

    tick() {
      const remaining = Math.max(0, this.deadline - Date.now());
      if (remaining <= 0) {
        if (this.expiredMode === 'restart') {
          this.deadline = Date.now() + this.minutes * 60 * 1000;
          try {
            window.sessionStorage.setItem(STORAGE_KEY, String(this.deadline));
          } catch (e) {
            /* ignore */
          }
          return;
        }
        this.hidden = true;
        window.clearInterval(this.interval);
        return;
      }
      const totalSeconds = Math.floor(remaining / 1000);
      const mm = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
      const ss = String(totalSeconds % 60).padStart(2, '0');
      if (this.timeEl) this.timeEl.textContent = `${mm}:${ss}`;
      this.hidden = false;
    }
  }
  customElements.define('atlasgrey-cart-timer', AtlasgreyCartTimer);
}

if (!customElements.get('atlasgrey-cart-upsell')) {
  class AtlasgreyCartUpsell extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-upsell-add]');
      this.button?.addEventListener('click', () => this.add());
      this.select = this.querySelector('[data-upsell-variant]');
      this.select?.addEventListener('change', () => this.selectVariant());
    }

    selectVariant() {
      const option = this.select?.selectedOptions[0];
      if (!option || !this.button) return;
      const { price, compare, url, image } = option.dataset;

      this.button.dataset.variantId = option.value;

      const priceEl = this.querySelector('[data-upsell-price]');
      if (priceEl && price) priceEl.textContent = price;

      const compareEl = this.querySelector('[data-upsell-compare]');
      if (compareEl) {
        compareEl.textContent = compare || '';
        compareEl.hidden = !compare;
      }

      const link = this.querySelector('[data-upsell-link]');
      if (link && url) link.href = url;

      const img = this.querySelector('img.agc-upsell__image');
      if (img && image) {
        img.removeAttribute('srcset');
        img.src = image;
      }
    }

    async add() {
      if (!this.button || this.button.disabled) return;
      const variantId = Number(this.button.dataset.variantId);
      if (!variantId) return;

      const label = this.button.querySelector('[data-upsell-label]');
      const originalText = label ? label.textContent : '';
      const loadingText = this.button.dataset.loadingText || '‚Ä¶';
      const addedText = this.button.dataset.addedText || '‚úì';

      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      this.button.disabled = true;
      if (label) label.textContent = loadingText;

      try {
        const cfg = fetchConfig('json', {
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        });
        const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', cfg);
        const json = await res.json();
        if (json.status) {
          console.error('[Atlasgrey Cart Upsell]', json.description || json.message);
          if (label) label.textContent = originalText;
          this.button.disabled = false;
          return;
        }
        const cartRes = await fetch(window.Theme?.routes?.cart_url ? `${window.Theme.routes.cart_url}.js` : '/cart.js', {
          headers: { Accept: 'application/json' },
        });
        const cart = cartRes.ok ? await cartRes.json() : undefined;
        if (label) label.textContent = addedText;
        this.dispatchEvent(
          new CartAddEvent(cart, this.id, {
            source: 'atlasgrey-cart-upsell',
            itemCount: cart?.item_count ?? 1,
            productId: Number(this.dataset.productId) || undefined,
            sections: json.sections,
          })
        );
      } catch (e) {
        console.error('[Atlasgrey Cart Upsell]', e);
        if (label) label.textContent = originalText;
        this.button.disabled = false;
      }
    }
  }
  customElements.define('atlasgrey-cart-upsell', AtlasgreyCartUpsell);
}
